export const percentageIncrease = (Number(process.env.REACT_APP_PERCENTAGE_INCREASE) || 50);
